"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const colors_1 = require("../../assets/jss/colors");
const styles = (theme) => (0, styles_1.createStyles)({
    media: {
        height: 350,
        display: 'flex',
        position: 'relative',
        objectFit: 'contain',
        [theme.breakpoints.down('md')]: {
            height: 208
        },
        [theme.breakpoints.down('xs')]: {
            height: 350
        }
    },
    jackpotText: {
        textTransform: 'none'
    },
    padding: {
        paddingBottom: theme.spacing(0.5)
    },
    card: {
        '&:focus, &:focus-visible': {
            outline: `2px solid ${colors_1.default.themeColors.white.hex()} !important`,
            border: `2px solid ${colors_1.default.themeColors.black.hex()} !important`,
            color: `${colors_1.default.themeColors.white.hex()} !important`
        }
    }
});
exports.default = styles;
//# sourceMappingURL=ListCardStyles.js.map